import React from 'react';
import { ArrowLeft } from 'lucide-react';
interface TermsPageProps {
  setCurrentPage: (page: 'home' | 'terms' | 'privacy') => void;
}
export function TermsPage({
  setCurrentPage
}: TermsPageProps) {
  const handleBack = () => {
    setCurrentPage('home');
    window.scrollTo(0, 0);
  };
  return <div className="min-h-screen bg-warm-white py-12 px-6" data-id="element-370">
      <div className="max-w-3xl mx-auto" data-id="element-371">
        <button onClick={handleBack} className="flex items-center gap-2 text-navy font-medium mb-8 hover:text-teal transition-colors" data-id="element-372">
          <ArrowLeft className="w-4 h-4" data-id="element-373" />
          Back to Home
        </button>

        <div className="bg-white p-8 md:p-12 rounded-xl shadow-sm border border-soft-sage/30" data-id="element-374">
          <h1 className="text-3xl md:text-4xl font-serif font-bold text-navy mb-2" data-id="element-375">
            Terms of Service
          </h1>
          <p className="text-muted mb-8" data-id="element-376">Last Updated: February 14, 2026</p>

          <div className="space-y-8 text-body leading-relaxed" data-id="element-377">
            <section data-id="element-378">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-379">1. Overview</h2>
              <p data-id="element-380">
                Welcome to The ER-Ready Mom Binder, operated by Better By Steps
                LLC ("we," "us," or "our"). By purchasing or using our digital
                products, you agree to be bound by these Terms of Service.
                Please read them carefully before making a purchase.
              </p>
            </section>

            <section data-id="element-381">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-382">
                2. Product Description
              </h2>
              <p data-id="element-383">
                The ER-Ready Mom Binder is a digital download (PDF format)
                designed to help parents organize medical information. It is an
                organizational tool, not a medical device or service.
              </p>
            </section>

            <section data-id="element-384">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-385">
                3. Purchase & Delivery
              </h2>
              <p data-id="element-386">
                This is a digital product. No physical item will be shipped.
                Upon successful payment, you will receive an email with a
                download link to access your PDF files instantly.
              </p>
            </section>

            <section data-id="element-387">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-388">
                4. Refund Policy
              </h2>
              <p data-id="element-389">
                We offer a 30-day "Peace of Mind Promise." If you are not
                satisfied with the product, please contact us at
                hello@betterbysteps.com within 30 days of purchase for a full
                refund.
              </p>
            </section>

            <section data-id="element-390">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-391">
                5. Intellectual Property
              </h2>
              <p data-id="element-392">
                Your purchase grants you a non-exclusive, non-transferable
                license for personal, non-commercial use. You may print copies
                for your immediate household and caregivers. You may NOT resell,
                redistribute, share the digital file, or use the content for
                commercial purposes without our express written permission.
              </p>
            </section>

            <section data-id="element-393">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-394">
                6. Medical Disclaimer
              </h2>
              <p className="font-medium text-navy/80 bg-cream p-4 rounded-lg border border-soft-sage/50" data-id="element-395">
                This product is for informational and organizational purposes
                only. It is NOT medical advice and is not a substitute for
                professional medical diagnosis, treatment, or care. Always seek
                the advice of your physician or other qualified health provider
                with any questions you may have regarding a medical condition.
                Never disregard professional medical advice or delay in seeking
                it because of something you have read in this binder.
              </p>
            </section>

            <section data-id="element-396">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-397">
                7. Limitation of Liability
              </h2>
              <p data-id="element-398">
                To the fullest extent permitted by law, Better By Steps LLC
                shall not be liable for any indirect, incidental, special,
                consequential, or punitive damages, or any loss of profits or
                revenues, whether incurred directly or indirectly, or any loss
                of data, use, goodwill, or other intangible losses, resulting
                from your use of our product.
              </p>
            </section>

            <section data-id="element-399">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-400">
                8. Changes to Terms
              </h2>
              <p data-id="element-401">
                We reserve the right to modify these terms at any time. Changes
                will be effective immediately upon posting to the website. Your
                continued use of our products constitutes acceptance of the
                modified terms.
              </p>
            </section>

            <section data-id="element-402">
              <h2 className="text-xl font-bold text-navy mb-3" data-id="element-403">
                9. Contact Information
              </h2>
              <p data-id="element-404">
                Questions about the Terms of Service should be sent to us at
                hello@betterbysteps.com.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>;
}